window.HistoricoFiltro = Backbone.Model.extend({

});

window.HistoricosFiltros = Backbone.Collection.extend({
    model: HistoricoFiltro
});
